import React, { useEffect } from 'react';
import api from "./api/api";
import ParkingItem from "./components/ParkingItem/ParkingItem";
import Header from "./components/layout/Header/Header";
import c from "./App.module.scss";
import IconRight from "./components/icons/IconRight";
import IconLeft from "./components/icons/IconLeft";
import IconTop from "./components/icons/IconTop";
import IconBottom from "./components/icons/IconBottom";



const renderIcon = (icon: DirectionIcon) => {
  switch (icon) {
    case 'left':
      return <IconLeft />;
    case 'right':
      return <IconRight />;
    case 'top':
      return <IconTop />;
    case 'bottom':
      return <IconBottom />;
  }
};

const directionVariants: Record<number, Record<number, DirectionIcon>> = {
  1: {
    1: 'bottom', // P1
    2: 'left',   // P2
    4: 'right',  // P14
    5: 'right',  // P15
    6: 'right',  // P15 (bus)
  },
  2: {
    1: 'left',
    2: 'top',
    4: 'bottom',
    5: 'bottom',
    6: 'bottom',
  },
  3: {
    1: 'right',
    2: 'bottom',
    4: 'top',
    5: 'top',
    6: 'top',
  },
  4: {
    1: 'left',
    2: 'top',
    4: 'top',
    5: 'top',
    6: 'top',
  },
  5: {
    1: 'right',
    2: 'bottom',
    4: 'bottom',
    5: 'bottom',
    6: 'bottom',
  },
};

function App() {
  const [data, setData] = React.useState<ParkingResponse>({ data: [], meta: { infoLink: '' } });

  const params = new URLSearchParams(window.location.search);
  const screen = Number(params.get('screen')) || 1;
  const parking = params.get('parking') || '[1,2,4,5,6]';

  const fetchData = () => {
    api.fetchParking().then((res) => {
      const updatedData = res.data.map((parking) => ({
        ...parking,
        direction: directionVariants[screen][parking.id],
      }));

      //remove buka parking from the list
      const list = updatedData.filter(item =>  JSON.parse(parking).includes(item.id)); // 7 is buka parking

      setData({
        ...res,
        data: list,
      });
    })
  }

  useEffect(() => {
    fetchData();

    // запит кожні 40 секунд
    const intervalId = setInterval(() => {
      fetchData();
    }, 40000);

    // очищення інтервалу
    return () => clearInterval(intervalId);
  }, []);



  return (
    <div className={c.parking}>
      <Header/>
      <ul>
        {
          data.data.map((item, index) => {
            const occupancyPercent = ((item.places - item.freePlaces) / item.places) * 100;

            return (
              <li key={item.id}>
                <ParkingItem
                  name={item.short_name}
                  description={item.short_descr}
                  percentage={Math.round(occupancyPercent)}
                  directionIcon={renderIcon(item.direction)}
                  freePlaces={item.freePlaces}/>
              </li>
            )
          })
        }
      </ul>
    </div>
  );
}

export default App;
